import { PricingTier } from "services/api/pricing/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const PRICE_TIER_COLUMNS: Column[] = [
  {
    title: "Razred (broj vozila)",
    field: "fromVehicle",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingTier) => (
      // Prazna gornja granica znači otvoren razred, ne nulu.
      <span className="text-slate-700">
        {row.fromVehicle} – {row.toVehicle === null ? "∞" : row.toVehicle}
      </span>
    ),
  },
  {
    title: "Udio pune cijene",
    field: "ratePercent",
    sortable: true,
    type: ColumnTypes.custom,
    render: (row: PricingTier) => (
      <span className="font-semibold text-slate-700">{row.ratePercent.toFixed(0)} %</span>
    ),
  },
];
